<template>
  <div>
    <StatsFilters
      :coachs="filterCoachs"
      :commercials="commercials"
      :coachManagers="coachManagers"
      :show-date="true"
      :is-conversion-stats="true"
      date-tooltip="Prend en compte la date de création de commande"
      @apply-filters="applyFilters"
    />

    <div class="animated fadeIn">
      <div class="card" v-if="!loading">
        <div class="card-block">
          <div class="row">
            <template v-if="archived">
              <div class="col-md-3">
                <label class="switch switch-sm switch-text switch-info mb-0">
                  <input
                    type="checkbox"
                    class="switch-input"
                    v-model="rankPending"
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
                En Attente
              </div>
              <div class="col-md-3">
                <label class="switch switch-sm switch-text switch-info mb-0">
                  <input
                    type="checkbox"
                    class="switch-input"
                    v-model="rankConversion"
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
                Converti
              </div>
              <div class="col-md-3">
                <label class="switch switch-sm switch-text switch-info mb-0">
                  <input
                    type="checkbox"
                    class="switch-input"
                    v-model="rankLost"
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
                Perdu
              </div>
            </template>
            <template v-else>
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-4">
                    <label
                      class="switch switch-sm switch-text switch-info mb-0"
                    >
                      <input
                        type="checkbox"
                        class="switch-input"
                        v-model="completed"
                      />
                      <span
                        class="switch-label"
                        data-on="On"
                        data-off="Off"
                      ></span>
                      <span class="switch-handle"></span>
                    </label>
                    Séance terminée
                  </div>
                </div>
              </div>
            </template>
            <div
              class="col-md-3 d-flex flex-column align-items-end"
              style="gap: 0.5rem"
            >
              <button
                class="btn btn-sm btn-primary"
                v-tooltip="{
                  content:
                    'Envoie un mail et une notification aux coachs qui ont des séances à planifier',
                  placement: 'top',
                }"
                @click="pushAllCoachModal()"
              >
                <i class="icon-paper-plane"></i> Push aux coachs
              </button>
              <button
                v-if="!archived"
                class="btn btn-sm btn-secondary"
                @click="archived = true"
              >
                Voir les archives
              </button>
              <button
                v-else
                class="btn btn-sm btn-primary"
                @click="archived = false"
              >
                Voir les séances à traiter
              </button>
            </div>
          </div>
          <div class="row">
            <div v-if="!archived && !completed" class="col-md-3">
              <label class="switch switch-sm switch-text switch-info mb-0">
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="notContacted"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              Pas contactés
            </div>
            <div v-if="!archived && !completed" class="col-md-3">
              <label class="switch switch-sm switch-text switch-info mb-0">
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="unScheduled"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              Non planifiées
            </div>
            <div v-if="!archived && !completed" class="col-md-3">
              <label class="switch switch-sm switch-text switch-info mb-0">
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="hasSchedule"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              Planifiées
            </div>
          </div>
          <div v-if="!archived && !completed" class="row mt-1">
            <div class="col-md-3">
              <label class="switch switch-sm switch-text switch-info mb-0">
                <input
                  v-model="hasReminder"
                  type="checkbox"
                  class="switch-input"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              Rappels
            </div>
          </div>
        </div>
      </div>

      <div class="card card-inverse card-info text-center" v-if="loading">
        <div class="card-block">
          <blockquote class="card-blockquote">
            Chargement en cours ...
          </blockquote>
        </div>
      </div>

      <div v-else class="card card-responsive">
        <div class="card-block">
          <div v-if="selected.length" class="mb-1">
            <button
              class="btn btn-sm btn-danger"
              :disabled="editing"
              @click="removeSelected"
            >
              <i class="fa fa-times mr-05" /> Retirer du suivi
            </button>
          </div>

          <el-table
            ref="table"
            :data="pagedOrders"
            :default-sort="sort"
            @selection-change="(rows) => (selected = rows)"
            @sort-change="sortChange"
          >
            <el-table-column
              v-if="
                hasPermission(
                  $store.state.user,
                  'SESSION_SCHEDULE_TRACKING_WRITE',
                )
              "
              type="selection"
              width="60"
            />

            <el-table-column
              type="index"
              label="#"
              width="60"
              :index="(index) => `#${(page - 1) * limit + index + 1}`"
            />

            <el-table-column width="30">
              <template slot-scope="scope">
                <i
                  v-if="scope.row.rank === 'conversion'"
                  class="text-success fa fa-check-circle"
                />
                <i
                  v-else-if="
                    scope.row.rank === 'lost' || scope.row.rank === 'lost_other'
                  "
                  class="text-danger fa fa-exclamation-circle"
                />
                <i v-else class="text-warning fa fa-circle" />
              </template>
            </el-table-column>

            <el-table-column :label="label" prop="client" width="210">
              <template slot-scope="scope">
                <div class="d-flex">
                  <a href="#" @click="(e) => goToClient(e, scope.row.clientId)">
                    {{ scope.row.client }}
                  </a>
                </div>
                <div>
                  <a href="#" @click="(e) => goToClient(e, scope.row.clientId)">
                    {{ scope.row.company }}
                  </a>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Commande" prop="id" width="150">
              <template slot-scope="scope">
                <a :href="orderHref(scope.row)" target="_blank">
                  <span v-if="scope.row.free">Offert</span>
                  <span v-else>{{ scope.row.price }}</span>
                  <i class="fa fa-external-link ml-05"></i>
                </a>
              </template>
            </el-table-column>

            <el-table-column
              label="Coachs"
              prop="coachs"
              sortable="custom"
              width="200"
            >
              <template slot-scope="scope">
                <span v-for="(name, i) in scope.row.coachsArray" :key="i">
                  <a @click="(e) => goToCoach(e, scope.row, name)" href="#">
                    {{ name }}
                    <i class="icon-user"></i>
                  </a>
                  <span v-if="i < scope.row.coachsArray.length - 1">, </span>
                </span>
              </template>
            </el-table-column>

            <el-table-column
              label="Contact client"
              prop="clientContactStatus.value"
              width="240"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.clientContactStatus.colorType"
                  @click="show(scope.row)"
                >
                  <i class="fa fa-eye mr-05" />
                  {{ scope.row.clientContactStatus.label }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="Notes" prop="notes" width="250">
              <template slot-scope="scope">
                <NoteModal
                  :notes="scope.row.conversion.notes"
                  :key="scope.row.id"
                  @showComment="showComment(scope.row)"
                  permission="CONVERSION_WRITE"
                  v-if="hasPermission($store.state.user, 'CONVERSION_WRITE')"
                />
                <span v-else>{{ scope.row.conversion.notes }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="Planifié le"
              prop="scheduledDate"
              sortable="custom"
              width="200"
            >
              <template slot-scope="scope">
                <span
                  v-bind:class="{
                    'font-weight-bold': now > scope.row.scheduledDate,
                  }"
                >
                  {{ scope.row.scheduledAt }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              :label="archived ? 'Archivé le' : 'Date commande'"
              prop="dateSort"
              width="160"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.date }}
              </template>
            </el-table-column>

            <el-table-column label="Notebook" prop="notebook" width="150">
              <template slot-scope="scope">
                <button
                  type="button"
                  class="btn btn-sm btn-secondary"
                  @click="showNotebook(scope.row)"
                  v-tooltip="concatedNotes(scope.row)"
                >
                  <i class="fa fa-commenting"></i>
                  ({{ scope.row.notebook ? scope.row.notebook.length : 0 }})
                  Consulter
                </button>
              </template>
            </el-table-column>

            <el-table-column
              label="Rappel"
              prop="reminderAt"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <label class="switch switch-sm switch-text switch-info">
                  <input
                    type="checkbox"
                    class="switch-input"
                    :checked="hasReminderOn(scope.row)"
                    @change="
                      (e) => {
                        e.target.checked = hasReminderOn(scope.row);
                        changeReminderAt(!hasReminderOn(scope.row), scope.row);
                      }
                    "
                    :disabled="
                      !hasPermission(
                        $store.state.user,
                        'SESSION_SCHEDULE_TRACKING_WRITE',
                      )
                    "
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
                <div v-if="scope.row.reminderAt" class="text-info">
                  {{ formatDate(scope.row.reminderAt) }}
                  <button
                    v-if="
                      hasPermission(
                        $store.state.user,
                        'SESSION_SCHEDULE_TRACKING_WRITE',
                      )
                    "
                    class="btn btn-sm btn-outline-info ml-05"
                    @click="changeReminderAt(true, scope.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="150" align="right">
              <template
                slot-scope="scope"
                v-if="
                  hasPermission(
                    $store.state.user,
                    'SESSION_SCHEDULE_TRACKING_WRITE',
                  )
                "
              >
                <button
                  class="btn btn-sm btn-primary mr-1"
                  v-if="!scope.row.scheduledAt && scope.row.coachs"
                  v-tooltip="{
                    content:
                      'Envoie un mail et une notification de rappel de planification des séances aux coachs',
                    placement: 'top',
                  }"
                  @click="pushToCoach(scope.row)"
                >
                  <i class="icon-paper-plane"></i>
                </button>
                <button
                  v-else
                  class="btn btn-sm btn-danger"
                  :disabled="editing"
                  @click="remove(scope.row)"
                >
                  <i class="fa fa-times" />
                </button>
              </template>
            </el-table-column>
          </el-table>

          <Paginate
            v-if="pageCount > 1"
            ref="paginate"
            class="mt-1"
            prev-text="Précédent"
            next-text="Suivant"
            container-class="pagination"
            :page-count="pageCount"
            :click-handler="(value) => (page = value)"
          />
        </div>
      </div>
    </div>

    <modal
      v-model="showModal"
      :title="title"
      effect="fade/zoom"
      cancelText="Annuler"
      okText="Enregistrer"
      large
      @ok="cancelOrderModal"
      @cancel="cancelOrderModal"
    >
      <template v-if="order">
        <el-radio-group
          :value="order.clientContactStatus.value"
          :disabled="
            updatingClientContactStatus ||
            !hasPermission($store.state.user, 'SESSION_SCHEDULE_TRACKING_WRITE')
          "
          @input="updateClientContactStatus"
        >
          <el-radio-button
            v-for="status in orderClientContactStatus"
            :key="status.value"
            :label="status.value"
          >
            {{ status.label }}
          </el-radio-button>
        </el-radio-group>

        <Sessions :sessions-data="order.sessions" />
      </template>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click="cancelOrderModal">
          Fermer
        </button>
      </div>
    </modal>

    <modal
      v-model="pushAll.display"
      title="Push aux coachs"
      effect="fade/zoom"
      cancelText="Annuler"
      okText="Envoyer"
      large
      @ok="pushNotifAllCoach()"
    >
      <p>
        Voulez-vous vraiment envoyer une notification à tous les coachs n'ayant
        pas planifié leurs séances ?
      </p>
      <div v-if="pushAll.result.display">
        <div v-for="result of pushAll.result.values" :key="result.id">
          <h4>{{ result.name }}</h4>
          <p>
            Email
            <i
              class="fa"
              :class="
                result.email ? 'fa-check text-success' : 'fa-times text-danger'
              "
            ></i>
          </p>
          <p>
            Notif
            <i
              class="fa"
              :class="
                result.notif ? 'fa-check text-success' : 'fa-times text-danger'
              "
            ></i>
          </p>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="pushAll.display = false"
        >
          Annuler
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="pushNotifAllCoach()"
        >
          Envoyer
        </button>
        <button
          v-if="pushAll.result.display"
          type="button"
          class="btn btn-success"
          @click="pushAll.display = false"
        >
          Valider
        </button>
      </div>
    </modal>

    <modal
      v-model="pushCoach.display"
      title="Envoyer un rappel"
      effect="fade/zoom"
      cancelText="Annuler"
      okText="Envoyer"
      large
      @ok="pushNotifCoach()"
    >
      <div v-if="pushCoach.order">
        <p>
          Voulez-vous vraiment envoyer une notification à
          <strong>{{ pushCoach.order.sessions[0].coachs[0].coach.name }}</strong
          >, concernant la commande de
          <strong> {{ this.pushCoach.order.client }} </strong>
        </p>
        <div v-if="pushCoach.result.display">
          <p>
            Email
            <i
              class="fa"
              :class="
                pushCoach.result.email
                  ? 'fa-check text-success'
                  : 'fa-times text-danger'
              "
            ></i>
          </p>
          <p>
            Notif
            <i
              class="fa"
              :class="
                pushCoach.result.notif
                  ? 'fa-check text-success'
                  : 'fa-times text-danger'
              "
            ></i>
          </p>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="pushCoach.display = false"
        >
          Annuler
        </button>
        <button type="button" class="btn btn-primary" @click="pushNotifCoach()">
          Envoyer
        </button>
        <button
          v-if="pushCoach.result.display"
          type="button"
          class="btn btn-success"
          @click="pushCoach.display = false"
        >
          Valider
        </button>
      </div>
    </modal>

    <ModalNotebook
      :show="modalNotebook.show"
      :notebook="modalNotebook.notebook"
      :client="modalNotebook.client"
      :order="modalNotebook.order"
      @close="closeNotebook"
    />

    <modal
      title="Commentaire"
      v-model="modalUpdateNoteConversion.showComment"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="updateComment()"
      effect="fade/zoom"
    >
      <textarea
        v-model="modalUpdateNoteConversion.form.notes"
        cols="30"
        rows="10"
        class="form-control form-normalization"
      >
      </textarea>
    </modal>

    <modal
      :title="
        editReminderAt.order && editReminderAt.order.reminderAt
          ? 'Modifier le rappel'
          : 'Ajouter un rappel'
      "
      v-model="editReminderAt.show"
      cancelText="Annuler"
      okText="Enregistrer"
      @cancel="closeReminderAtModal"
      effect="fade/zoom"
    >
      <div class="form-group">
        <label
          >Rappel équipe
          <el-popover
            placement="top"
            trigger="hover"
            class="ml-05"
            :width="360"
            :content="'Un mail de rappel sera envoyé à l\'équipe 7 jours avant la date sélectionnée'"
          >
            <template #reference
              ><i class="fa fa-info-circle"></i
            ></template> </el-popover
        ></label>
        <Datepicker
          v-model="editReminderAt.reminderDate"
          format="dd.MM.yyyy"
          language="fr"
          input-class="form-control"
          :disabled="reminderDisabledDates"
        ></Datepicker>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="closeReminderAtModal"
        >
          Annuler
        </button>

        <button
          type="button"
          class="btn btn-primary"
          :disabled="editing"
          @click="saveReminderAt()"
        >
          Enregistrer
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Modal from "vue-strap/src/Modal";
import Sessions from "@/components/session/Sessions";
import StatsFilters from "@/components/stats/StatsFilters";
import ModalNotebook from "@/components/modal/ModalNotebook";
import NoteModal from "@/components/form/NoteModal";
import Datepicker from "vuejs-datepicker";
import Paginate from "vuejs-paginate";

export default {
  components: {
    Modal,
    Sessions,
    StatsFilters,
    ModalNotebook,
    NoteModal,
    Datepicker,
    Paginate,
  },

  data() {
    return {
      loading: true,
      editing: false,
      updatingClientContactStatus: false,
      archived: false,
      filter: {},
      selected: [],
      sort: { prop: "scheduledDate", order: "descending" },
      page: 1,
      limit: 20,
      pushAll: {
        display: false,
        result: {
          display: false,
          values: [],
        },
      },
      pushCoach: {
        display: false,
        coach: null,
        result: {
          display: false,
          email: false,
          notif: false,
        },
      },
      completed: false,
      rankPending: true,
      rankConversion: true,
      rankLost: true,
      rankOther: true,
      unScheduled: false,
      notContacted: false,
      hasSchedule: false,
      hasReminder: false,
      order: null,
      clientLost: {
        isLost: false,
        lostReason: null,
        detailLostReason: null,
      },
      showModal: false,
      now: moment().unix(),
      clients: {},
      commercials: [],
      coachManagers: [],
      modalNotebook: {
        show: false,
        notebook: [],
        client: {},
        order: {},
      },
      modalUpdateNoteConversion: {
        showComment: false,
        form: {
          orderId: null,
          notes: "",
        },
      },
      editReminderAt: {
        show: false,
        order: null,
        reminderDate: moment().toDate(),
      },
      reminderDisabledDates: {
        to: moment().toDate(),
      },
    };
  },

  computed: {
    ...mapGetters({
      orderClientContactStatus: "getOrderClientContactStatus",
    }),

    label() {
      return "Clients (" + this.orders.length + ")";
    },

    title() {
      if (this.order) {
        return this.order.client + " - " + this.formatPack(this.order.session);
      }
      return "";
    },

    filterCoachs() {
      let coachs = {};
      for (let email in this.clients) {
        if (Object.prototype.hasOwnProperty.call(this.clients, email)) {
          this.clients[email].forEach((order) => {
            order.sessions.forEach((session) => {
              session.coachs.forEach((coach) => {
                coachs[coach.coach.name] = true;
              });
            });
          });
        }
      }
      return Object.keys(coachs);
    },

    defaultOrderClientContactStatus() {
      return this.orderClientContactStatus.find(
        (s) => s.value === "not-contacted",
      );
    },

    orders() {
      let orders = [];
      for (let email in this.clients) {
        if (
          Object.prototype.hasOwnProperty.call(this.clients, email) &&
          (!this.filter.client || email === this.filter.client.value)
        ) {
          if (
            this.filter.concept &&
            !this.clients[email].find((o) => o.concept === this.filter.concept)
          ) {
            continue;
          }
          if (
            this.filter.status &&
            !this.clients[email].find(
              (o) => o.status === this.filter.status.value,
            )
          ) {
            continue;
          }

          this.clients[email].forEach((order) => {
            let coachs = {};
            let completed = 0;

            if (this.filter.concept && order.concept !== this.filter.concept) {
              return;
            }

            if (
              this.filter.status &&
              order.status !== this.filter.status.value
            ) {
              return;
            }

            if (this.archived) {
              if (!this.rankPending && order.rank === "pending") {
                return;
              }
              if (!this.rankConversion && order.rank === "conversion") {
                return;
              }
              if (!this.rankLost && order.rank === "lost") {
                return;
              }
              if (!this.rankLostOther && order.rank === "lost_other") {
                return;
              }
              if (
                this.filter.begin &&
                moment(this.filter.begin) > moment(order.archivedAt)
              ) {
                return;
              }
              if (
                this.filter.end &&
                moment(this.filter.end) < moment(order.archivedAt)
              ) {
                return;
              }
            } else if (
              this.unScheduled ||
              this.hasSchedule ||
              this.notContacted ||
              this.completed
            ) {
              let filtered = true;

              if (
                this.unScheduled &&
                !order.sessions.some(
                  (session) => session.completed || session.scheduledAt,
                )
              ) {
                filtered = false;
              }

              if (
                this.notContacted &&
                (!order.clientContactStatus ||
                  order.clientContactStatus === "not-contacted")
              ) {
                filtered = false;
              }
              if (this.hasSchedule) {
                for (const session of order.sessions) {
                  if (session.completed) {
                    continue;
                  }

                  if (session.scheduledAt && session.assignedAt) {
                    filtered = false;
                  }

                  break;
                }
              }

              if (this.completed && order.completed) {
                filtered = false;
              }

              if (filtered) {
                return;
              }
              if (this.filterByDate(order)) {
                return;
              }
            } else {
              if (this.filterByDate(order)) {
                return;
              }
            }

            if (this.filter.inactive) {
              if (!order.completed || order.packs > 0) {
                return;
              }

              let diff = moment().diff(
                moment(order.completedAt || order.createdAt),
                "month",
              );
              if (
                !(this.filter.inactive.value === "4m-more" && diff >= 4) ||
                (this.filter.inactive.value === "3m" && diff === 3) ||
                (this.filter.inactive.value === "2m" && diff === 2) ||
                (this.filter.inactive.value === "1m" && diff === 1)
              ) {
                return;
              }
            }

            order.sessions.forEach((session) => {
              session.coachs.forEach((coach) => {
                coachs[coach.coach.name] = true;
              });
              if (session.completed) {
                completed++;
              }
            });

            if (this.filter.coach && !coachs[this.filter.coach]) {
              return;
            }

            if (this.hasReminder) {
              if (!order.reminderAt) {
                return;
              }
            } else if (order.reminderAt) {
              return;
            }

            orders.push({
              ...order,
              coachs: Object.keys(coachs).join(", "),
              coachsArray: Object.keys(coachs),
              pack: this.formatPack(order.session),
              price: this.formatPrice(order.price),
              orders: this.clients[email].length,
              state: completed + "/" + order.sessions.length,
              date: this.archived
                ? this.formatDate(order.archivedAt)
                : this.formatDate(order.createdAt),
              dateSort: this.archived
                ? moment(order.archivedAt).unix()
                : moment(order.createdAt).unix(),
              scheduledAt:
                order.sessions && order.sessions.length
                  ? this.formatDateTime(order.sessions[0].scheduledAt)
                  : null,
              scheduledDate:
                order.sessions &&
                order.sessions.length &&
                order.sessions[0].scheduledAt
                  ? moment(order.sessions[0].scheduledAt).unix()
                  : 0,
              notes:
                order.conversion && order.conversion.notes
                  ? order.conversion.notes.length > 60
                    ? order.conversion.notes.substr(0, 60) + "..."
                    : order.conversion.notes
                  : "",
              clientContactStatus:
                this.orderClientContactStatus.find(
                  (s) => s.value === order.clientContactStatus,
                ) || this.defaultOrderClientContactStatus,
            });
          });
        }
      }
      return orders;
    },

    sortedOrders() {
      const { prop, order } = this.sort;

      if (!prop || !order) {
        return this.orders;
      }

      const direction = order === "descending" ? -1 : 1;

      return [...this.orders].sort((a, b) => {
        if (a[prop] < b[prop]) {
          return -direction;
        }
        if (a[prop] > b[prop]) {
          return direction;
        }
        return 0;
      });
    },

    pageCount() {
      return Math.ceil(this.orders.length / this.limit);
    },

    pagedOrders() {
      const start = (this.page - 1) * this.limit;

      return this.sortedOrders.slice(start, start + this.limit);
    },

    isProspect() {
      return this.order?.refClient?.prospect?.isProspect;
    },

    isLost() {
      return (
        this.clientLost.isLost ||
        this.order?.rank === "lost" ||
        this.order?.rank === "lost_other"
      );
    },
  },

  async created() {
    await this.fetchCommercials();
    await this.fetchCoachManagers();

    this.filter.commercial = this.commercials.find((c) => {
      if (this.$store.state.user.email === c.value) {
        return c;
      }
    });

    this.filter.coachManager = this.coachManagers.find((c) => {
      if (this.$store.state.user.email === c.value) {
        return c;
      }
    });

    await this.loadOrders();
  },

  methods: {
    async loadOrders() {
      this.clearSelection();

      try {
        let params = {};

        if (this.archived) {
          params.archived = this.archived;
        }

        if (this.filter.commercial) {
          params.commercial = this.filter.commercial.value;
        }

        if (this.filter.coachManager) {
          params.coachManager = this.filter.coachManager.value;
        }

        this.loading = true;

        const { data } = await this.$api.get(
          "/orders/session-schedule-tracking",
          { params },
        );

        this.clients = data;
      } catch (e) {
        this.$errorToast(
          "Impossible de charger les packs avec suivi de planification",
        );
      } finally {
        this.loading = false;
      }
    },

    onSave() {
      if (this.isLost && this.order.refClient) {
        const data = {
          email: this.order.refClient.email,
        };

        if (this.isProspect) {
          data.prospect = {
            type: "perdu",
            lostReason: this.clientLost.lostReason,
            detailLostReason: this.clientLost.detailLostReason,
            lostAt: moment().toDate(),
          };
        } else {
          data.status = "lost";
          data.lostReason = this.clientLost.lostReason;
          data.detailLostReason = this.clientLost.detailLostReason;
          data.lostAt = moment().toDate();
        }

        this.$confirm({
          message:
            "Le client/prospect va changer de statut. Souhaitez-vous continuer ?",
          onConfirm: async () => {
            try {
              await this.$api.patch("/clients/status", data);

              this.save();
            } catch (e) {
              this.order = null;
              this.clientLost.isLost = false;
              this.clientLost.lostReason = null;
              this.clientLost.detailLostReason = null;
              this.showModal = false;
              this.$errorToast("Un problème est survenu");

              return;
            }
          },
        });
      } else {
        this.save();
      }
    },

    async save() {
      await this.$api.put("/orders/conversion/" + this.order.id, {
        rank: this.order.rank,
        conversion: this.order.conversion,
      });

      const updatedOrder = this.orders.find(
        (order) => order.id === this.order.id,
      );

      if (this.isProspect) {
        updatedOrder.refClient.prospect.type = "perdu";
        updatedOrder.refClient.prospect.lostReason = this.clientLost.lostReason;
      } else {
        updatedOrder.refClient.status = "lost";
        updatedOrder.refClient.lostReason = this.clientLost.lostReason;
      }

      this.order = null;
      this.clientLost.isLost = false;
      this.clientLost.lostReason = null;
      this.clientLost.detailLostReason = null;
      this.showModal = false;
    },

    cancelOrderModal() {
      this.showModal = false;
      this.order = null;
      this.clientLost.isLost = false;
      this.clientLost.lostReason = null;
      this.clientLost.detailLostReason = null;
    },

    filterByDate(order) {
      if (
        this.filter.begin &&
        moment(this.filter.begin).startOf("day") > moment(order.createdAt)
      ) {
        return true;
      }

      return (
        this.filter.end &&
        moment(this.filter.end).endOf("day") < moment(order.createdAt)
      );
    },
    pushToCoach(order) {
      this.pushCoach.order = order;
      this.pushCoach.display = true;
      this.pushCoach.result.display = false;
    },

    async pushNotifCoach() {
      const result = await this.requestPushConversion(this.pushCoach.order.id);

      this.pushCoach.result.display = true;
      this.pushCoach.result.email = result.email;
      this.pushCoach.result.notif = result.notif;
    },

    pushAllCoachModal() {
      this.pushAll.display = true;
      this.pushAll.result.display = false;
    },

    async pushNotifAllCoach() {
      for (let order of this.orders) {
        if (!order.scheduledAt && order.coachs) {
          const result = await this.requestPushConversion(order.id);

          this.pushAll.result.display = true;
          this.pushAll.result.values.push({
            id: order.id,
            name: order.coachsArray[0],
            email: result.email,
            notif: result.notif,
          });
        }
      }
    },

    async requestPushConversion(orderId) {
      try {
        const { data } = await this.$api.patch(
          `/orders/${orderId}/conversion/push`,
        );

        return data;
      } catch (e) {
        console.log(e);
      }
    },

    show(order) {
      this.order = order;

      if (
        this.order.conversion?.price &&
        typeof this.order.conversion.price === "number"
      ) {
        this.order.conversion.price = this.order.conversion.price.toFixed(2);
      }

      if (order.refClient) {
        if (order.refClient?.prospect?.isProspect) {
          this.clientLost.lostReason = order.refClient.prospect.lostReason;
          this.clientLost.detailLostReason =
            order.refClient.prospect.detailLostReason;
        } else {
          this.clientLost.lostReason = order.refClient.lostReason;
          this.clientLost.detailLostReason = order.refClient.detailLostReason;
        }
      }

      this.$nextTick(() => {
        this.showModal = true;
      });
    },

    getDelay(value) {
      if (!value) {
        return "inconnu";
      }

      const now = moment();
      const duration = moment.duration(now.diff(value));
      const hours = duration.asHours();
      const minutes = duration.asMinutes();

      return hours > 1
        ? `${Math.round(hours)} h`
        : `${Math.round(minutes)} min`;
    },

    remove(order) {
      const message =
        order.rank === "pending"
          ? 'La séance est toujours "En attente"... retirer quand même du suivi de planification ?'
          : "Retirer du suivi de planification ?";

      this.$confirm({
        message,
        onConfirm: async () => {
          if (this.editing) {
            return;
          }

          try {
            this.editing = true;

            await this.$api.put(`/orders/${order.id}`, {
              sessionScheduleTracking: false,
            });

            this.sliceOrder(order.id);
          } finally {
            this.editing = false;
          }
        },
      });
    },

    removeSelected() {
      const orders = [...this.selected];
      const hasPending = orders.some((order) => order.rank === "pending");

      this.$confirm({
        message:
          `Retirer les ${orders.length} commandes du suivi de planification ?` +
          (hasPending
            ? ' Certaines séances sont toujours "En attente"...'
            : ""),
        onConfirm: async () => {
          if (this.editing) {
            return;
          }

          try {
            this.editing = true;

            const results = await Promise.allSettled(
              orders.map((order) =>
                this.$api
                  .put(`/orders/${order.id}`, {
                    sessionScheduleTracking: false,
                  })
                  .then(() => this.sliceOrder(order.id)),
              ),
            );

            const failed = results.filter(
              (result) => result.status === "rejected",
            ).length;

            this.clearSelection();

            if (failed) {
              this.$errorToast(
                `${failed} commande(s) n'ont pas pu être retirée(s) du suivi`,
              );
            }
          } finally {
            this.editing = false;
          }
        },
      });
    },

    clearSelection() {
      this.selected = [];
      this.$refs.table?.clearSelection();
    },

    sortChange({ prop, order }) {
      this.sort = { prop, order };
      this.page = 1;
    },

    sliceOrder(orderId) {
      for (let email in this.clients) {
        if (Object.prototype.hasOwnProperty.call(this.clients, email)) {
          let index = this.clients[email].findIndex(
            (order) => order.id === orderId,
          );
          if (index === -1) {
            continue;
          }
          if (index === 0 && this.clients[email].length > 1) {
            this.clients[email][1].refClient = this.clients[email][0].refClient;
          }
          this.clients[email].splice(index, 1);
        }
      }
    },

    isScheduled(order) {
      for (const session of order.sessions) {
        if (session.completed) {
          continue;
        }

        return session.scheduledAt && session.assignedAt;
      }
    },

    isUnScheduled(order) {
      for (const session of order.sessions) {
        if (session.completed) {
          continue;
        }

        return !session.scheduledAt && session.assignedAt;
      }
    },

    orderHref(order) {
      const route = this.$router.resolve({
        name: "order-details",
        params: {
          id: order.id,
        },
      });

      return route.href;
    },

    goToCoach(e, order, name) {
      e.preventDefault();

      let myCoach;

      order.sessions.forEach((session) => {
        session.coachs.forEach((coach) => {
          if (coach.coach.name === name) {
            myCoach = coach;
          }
        });
      });

      const routeData = this.$router.resolve({
        name: "user-details",
        params: {
          id: myCoach.id,
        },
      });

      window.open(routeData.href, "_blank");
    },

    goToClient(e, id) {
      e.preventDefault();

      const route = this.$router.resolve({
        name: "client-details",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },

    async fetchCommercials() {
      const { data } = await this.$api.get("/users/commercials/search");

      this.commercials = data.map((c) => ({
        value: c.email,
        label: c.commercial.pseudo,
      }));
    },

    async fetchCoachManagers() {
      const { data } = await this.$api.get("/users/coach-managers");

      this.coachManagers = data.map((c) => ({
        value: c.email,
        label: c.coachManager.pseudo,
      }));
    },

    applyFilters(form) {
      this.filter = { ...form };
      this.page = 1;

      this.loadOrders();
    },

    showNotebook(order) {
      this.modalNotebook.show = true;
      this.modalNotebook.notebook = order.notebook;
      this.modalNotebook.client = order.refClient;
      this.modalNotebook.order = order;
    },

    closeNotebook() {
      this.modalNotebook.show = false;
      this.modalNotebook.notebook = [];
      this.modalNotebook.client = {};
      this.modalNotebook.order = {};
    },

    concatedNotes(order) {
      return (
        order.notebook
          .filter((n) => n.orderId === order.id)
          .map((note) => `${note.title}: ${note.note}`)
          .join(" | ") || "Aucune note pour cette commande"
      );
    },

    showComment(order) {
      this.modalUpdateNoteConversion.showComment = true;
      this.modalUpdateNoteConversion.form.orderId = order.id;
      this.modalUpdateNoteConversion.form.notes = order.conversion.notes;
    },

    async updateComment() {
      await this.$api.put(
        `/orders/conversion-notes/${this.modalUpdateNoteConversion.form.orderId}`,
        {
          notes: this.modalUpdateNoteConversion.form.notes,
        },
      );

      this.modalUpdateNoteConversion = {
        showComment: false,
        form: {
          orderId: null,
          notes: "",
        },
      };

      this.loadOrders();
    },

    async updateClientContactStatus(newStatus) {
      if (!this.order || this.updatingClientContactStatus) {
        return;
      }

      const prevStatus = this.order.clientContactStatus;

      try {
        this.updatingClientContactStatus = true;
        this.order.clientContactStatus =
          this.orderClientContactStatus.find((s) => s.value === newStatus) ||
          this.defaultOrderClientContactStatus;

        await this.$api.put(`/orders/${this.order.id}`, {
          clientContactStatus: newStatus,
        });

        for (const email in this.clients) {
          const clientOrder = this.clients[email].find(
            (o) => o.id === this.order.id,
          );

          if (clientOrder) {
            clientOrder.clientContactStatus = newStatus;

            break;
          }
        }
      } catch (e) {
        this.order.clientContactStatus = prevStatus;

        this.$errorToast(
          "Impossible de mettre à jour le statut de contact du client",
        );
      } finally {
        this.updatingClientContactStatus = false;
      }
    },

    hasReminderOn(order) {
      return !!order.reminderAt;
    },

    changeReminderAt(enable, order) {
      if (enable) {
        this.editReminderAt.order = order;
        this.editReminderAt.show = true;
        this.editReminderAt.reminderDate = order.reminderAt
          ? moment(order.reminderAt).toDate()
          : moment().toDate();
      } else {
        this.$confirm({
          message:
            "Voulez-vous vraiment supprimer le rappel pour cette commande ?",
          onConfirm: () => this.saveReminderAt(order.id, null),
        });
      }
    },

    closeReminderAtModal() {
      this.editReminderAt.show = false;
      this.editReminderAt.order = null;
      this.editReminderAt.reminderDate = moment().toDate();
    },

    async saveReminderAt(orderId, reminderDate) {
      if (this.editing) {
        return;
      }

      try {
        this.editing = true;

        const id = orderId || this.editReminderAt.order.id;
        const reminderAt =
          reminderDate !== undefined
            ? reminderDate
            : this.editReminderAt.reminderDate;

        await this.$api.put(`/orders/${id}`, {
          reminderAt,
        });

        for (const email in this.clients) {
          const index = this.clients[email].findIndex((o) => o.id === id);

          if (index !== -1) {
            this.clients[email].splice(index, 1, {
              ...this.clients[email][index],
              reminderAt,
            });

            break;
          }
        }
        this.closeReminderAtModal();

        this.$successToast(reminderAt ? "Rappel modifié" : "Rappel supprimé");
      } catch (e) {
        this.$errorToast(
          "Impossible de mettre à jour le rappel pour cette commande",
        );
      } finally {
        this.editing = false;
      }
    },
  },

  watch: {
    page() {
      this.clearSelection();

      if (
        this.$refs.paginate &&
        this.page - 1 !== this.$refs.paginate.selected
      ) {
        this.$refs.paginate.selected = this.page - 1;
      }
    },

    pageCount(value) {
      if (this.page > value) {
        this.page = Math.max(value, 1);
      }
    },

    archived() {
      this.page = 1;
      this.$nextTick(() => this.loadOrders());
    },
  },
};
</script>

<style scoped>
.table-responsive {
  text-overflow: none;
}
.card-responsive {
  display: block;
  overflow-x: scroll;
}
</style>
